"use client";

import { createContext, useContext, useState } from "react";

const ConfigMessageContext = createContext();

function ConfigMessageProvider({ children }) {
  const [configMessage, setConfigMessage] = useState("");
  // "Thank you for configuring your selection! Here are the details of your custom configuration:\n\n- Model: The Living Module\n- Module: Three Modules\n- Interior: Premium\n- Exterior: Luxury\n- Customizations: Renewable Energy Systems, Smart Home Solutions\n\nIf everything looks good, please submit the form. If you need any assistance, feel free to reach out to our team."

  return (
    <ConfigMessageContext.Provider value={{ configMessage, setConfigMessage }}>
      {children}
    </ConfigMessageContext.Provider>
  );
}

function useConfigMessage() {
  const context = useContext(ConfigMessageContext);

  if (!context)
    throw new Error("Config Message Context was used outside the provider");

  return context;
}

export { ConfigMessageProvider, useConfigMessage };
